import { ChoiceStatus as ChoiceStatusEnum } from '../generated/types';
import { ChoiceStatus } from '../generated/types.cms';

export function cmsChoiceStatusMap(
  status: ChoiceStatusEnum
): keyof Omit<
  ChoiceStatus,
  '__typename' | 'updatedAt' | 'createdAt' | 'localizations' | 'locale'
> {
  switch (status) {
    case ChoiceStatusEnum.Approved: {
      return 'approved';
    }
    case ChoiceStatusEnum.Canceled: {
      return 'canceled';
    }
    case ChoiceStatusEnum.Confirmed: {
      return 'confirmed';
    }
    case ChoiceStatusEnum.Pending: {
      return 'pending';
    }
    case ChoiceStatusEnum.Selected: {
      return 'selected';
    }
    case ChoiceStatusEnum.Submitted: {
      return 'submitted';
    }
    default: {
      return 'approved';
    }
  }
}
